import script from "./NewsMain.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsMain.vue?vue&type=script&setup=true&lang=js"

import "./NewsMain.vue?vue&type=style&index=0&id=5a1e7544&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a1e7544"]])

export default __exports__